import React from 'react';
import { Box, Typography, Button, Grid, Paper } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useHistory } from 'react-router-dom';

const CatalogImageryDoc = () => {
  const history = useHistory();

  const steps = [

    {
      title: 'Catalog Orders - Searching for Imagery',
      intro: 'When placing a catalog order, search and select from available images.',
      points: [
        '• Draw or upload an AOI to define your area of interest.',
        '• Set a date range for the imagery you are looking for.',
        '• Filter results based on cloud cover, resolution, and off-nadir angle.',
        '• Hover over images to preview and click to select them.'
      ],
      image: '/images/catalog_search.png'
    },
    {
      title: 'Catalog Orders - Proceeding to Checkout',
      intro: 'Finalize your catalog imagery selections and submit your order.',
      points: [
        '• After selecting images, click the Checkout button.',
        '• Choose processing level (e.g., orthorectified) and delivery format.',
        '• Review selected imagery, costs, and order details.',
        '• Enter an order name and optional description before confirming.'
      ],
      image: '/images/catalog_checkout.png'
    },
  ];

  return (
    <Box sx={{ maxWidth: '1000px', mx: 'auto', p: 4 }}>
      <Button startIcon={<ArrowBackIcon />} sx={{ mb: 4, color: '#1976d2' }} onClick={() => history.goBack()}>
        Back to Documentation
      </Button>

      <Typography variant="h4" sx={{ mb: 4, fontWeight: 'bold', color: '#1976d2' }}>
        Placing Orders - Catalog 
      </Typography>

      {steps.map((step, index) => (
        <Paper elevation={3} sx={{ p: 3, mb: 4, borderRadius: 2 }} key={index}>
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={12} md={6}>
              <Typography variant="h6" sx={{ mb: 2, color: '#333', fontWeight: 600 }}>{`${index + 1}. ${step.title}`}</Typography>
              <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>{step.intro}</Typography>
              {step.points.map((point, idx) => (
                <Typography key={idx} variant="body2" color="text.secondary" sx={{ ml: 2, mb: 1 }}>{point}</Typography>
              ))}
            </Grid>
            <Grid item xs={12} md={6}>
              <Box
                component="img"
                src={step.image}
                alt={step.title}
                sx={{ 
                  width: '100%', 
                  maxWidth: '500px',
                  maxHeight: '400px',
                  height: 'auto', 
                  objectFit: 'contain',
                  borderRadius: 2, 
                  boxShadow: 3 
                }}
              />
            </Grid>
          </Grid>
        </Paper>
      ))}
    </Box>
  );
};

export default CatalogImageryDoc;
